module.exports = __webpack_public_path__ + "media/images/ecalls/icon_clock_ice-e15c60cb19b5027d9806f59574e2e11f.png";